import React from "react";
import { ArrRefresh2O } from "lovedicons/dist/arrO";

const Loading = () => {
  return (
    <div className="flex">
      <ArrRefresh2O className="w-6 h-6 mr-2 animate-spin" />
      <div>Loading...</div>
    </div>
  );
};

export default Loading;
